export const paymentGate = Object.freeze({
  FAST_SPRING: 'fastspring',
  STRIPE: 'stripe',
});
